module.exports = __webpack_public_path__ + "static/media/1.96ee2628.jpg";